module.exports = __webpack_public_path__ + "media/icons/search-c4127766.svg";